import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { UserUpdateComponent } from './pages';

const USER_ROUTES: Routes = [
  {
    path: 'update',
    component: UserUpdateComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(USER_ROUTES)],
  exports: [RouterModule],
})
export class UserRoutingModule {}
